import { AxiosResponse } from 'axios';
import { HttpClientFactory } from '@/shared/services/HttpClientFactory';
import { StatEvent } from '../plugins/StatisticsPlugin/IgcStatisticsService';

export const STAT_ACCESS_URL = '/api/v1/access/statistics/events';

export const logEvent = (evt: StatEvent): Promise<any> => HttpClientFactory.baseClientSilent
  .post(STAT_ACCESS_URL, evt)
  .then((res: AxiosResponse) => res.data);

export const logEvents = (evt: StatEvent[]): Promise<any> => HttpClientFactory.baseClientSilent
  .post(`${STAT_ACCESS_URL}/bulk`, evt)
  .then((res: AxiosResponse) => res.data);
